import React, { useEffect, useState } from "react";

import healthImage from "/asset/image/healthInfo.png";
import medicalInfoImage from "/asset/image/medicalInfo.png";
import telehealthImage from "/asset/image/telehealth.png";
import wellnessImage from "/asset/image/wellness.png";
import useTranslation from "/hook/useTranslation/useTranslation";

import TutorialScreenBase from "./TutorialScreenBase";

const MAX_SCREENS = 4;

const CreateAccountTutorial = () => {
  const { t } = useTranslation("screen-generalTutorials");
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);
  const tutorialScreens = [
    {
      title: t("createAccount1.title"),
      subTitle: t("createAccount1.subTitle"),
      image: medicalInfoImage,
    },
    {
      title: t("createAccount2.title"),
      subTitle: t("createAccount2.subTitle"),
      image: telehealthImage,
    },
    {
      title: t("createAccount3.title"),
      subTitle: t("createAccount3.subTitle"),
      image: healthImage,
    },
    {
      title: t("createAccount4.title"),
      subTitle: t("createAccount4.subTitle"),
      image: wellnessImage,
    },
  ];

  const setupTutorialScreen = () => {
    setInterval(() => {
      setCurrentScreenIndex((currentScreenIndex) => (currentScreenIndex + 1) % MAX_SCREENS);
    }, 5000);
  };

  useEffect(() => {
    setupTutorialScreen();
  }, []);

  const currentScreen = tutorialScreens[currentScreenIndex || 0];

  return (
    <TutorialScreenBase
      title={currentScreen.title}
      subtitle={currentScreen.subTitle}
      image={currentScreen.image}
      currentScreenIndex={currentScreenIndex}
      maxScreens={MAX_SCREENS}
    />
  );
};

export default CreateAccountTutorial;
